import { TableTemplate } from 'types/tableTemplate';

export const packageTableTemplate: TableTemplate[] = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'name',
    description: 'Nome',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'formattedCostPrice',
    description: 'Custo',
    originalId: 'cost_price',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedSalePriceMin',
    description: 'Venda Mín',
    originalId: 'sale_price_min',
    width: 150,
    dataType: 'number',
  },
  {
    id: 'formattedSalePriceMax',
    description: 'Venda Máx',
    originalId: 'sale_price_max',
    width: 150,
    dataType: 'number',
  },
  {
    id: 'formattedSupplierName',
    description: 'Fornecedor',
    originalId: 'formattedSupplierName',
    width: 250,
  },
];
